import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import { API } from 'aws-amplify';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Spin from 'components/common/Spin';
import { formatCurrency } from 'utils';
import useSnack from "hooks/useSnack";

const API_URL = process.env.REACT_APP_API_HOST;

const renderTierPrices = (tier) => {
  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        borderBottom="1px solid #ccc"
      >
        <Typography variant="subtitle2">Tier 1 or Early Round:</Typography>
        <Typography variant="subtitle2">
          +{formatCurrency(tier[0])}
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        borderBottom="1px solid #ccc"
      >
        <Typography variant="subtitle2">Tier 2:</Typography>
        <Typography variant="subtitle2">
          +{formatCurrency(tier[1])}
        </Typography>
      </Box>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="subtitle2">Tier 3:</Typography>
        <Typography variant="subtitle2">
          +{formatCurrency(tier[2])}
        </Typography>
      </Box>
    </Box>
  );
};

const SubscriptionDetails = ({ student, subscription }) => {
  const [customer, setCustomer] = useState();
  const snack = useSnack();
  useEffect(() => {
    API.get('api', `/stripe/customers/${student.stripe_customer_id}`).then(
      (resp) => {
        console.log(resp);
        setCustomer(resp);
      },
      (e) => {
        console.log(e)
        snack.error('Error loading card details');
      }
    );
  }, []);

  const source = customer?.sources.data[0];

  return (
    <div>
      <Helmet title="Subscription details" />
      <Grid container>
        <Grid item md={6}>
          <Card>
            <CardHeader
              style={{ paddingBottom: 0 }}
              title={subscription.plan_id.replace(/_/g, ' ')}
              subheader={`Support until ${subscription.end_date}`}
            />
            <CardContent>
              <Typography variant="caption">
                {subscription.tier_prices ? 'Upfront Payment' : 'Total Cost'}
              </Typography>
              <Typography variant="h5">
                {formatCurrency(subscription.total)}
              </Typography>
              <br />
              <Grid container>
                <Grid item md={6}>
                  <Typography gutterBottom variant="subtitle2">
                    Payment Plan:{' '}
                    {subscription.installments
                      ? 'Installment'
                      : subscription.tier_prices
                      ? 'Deferred Success'
                      : 'One time'}
                  </Typography>
                  <Typography variant="caption">Payment Method</Typography>
                  {!customer ? (
                    <Spin spinning />
                  ) : (
                    <Typography variant="subtitle2">
                      {source.brand} ending with {source.last4}
                    </Typography>
                  )}
                </Grid>
                <Grid item md={6}>
                  {subscription.installments ? (
                    <Box textAlign="right">
                      <Typography variant="h5">
                        {formatCurrency(subscription.installment_amount)}
                        <small>/mo</small>
                      </Typography>
                      <Typography color="textPrimary" variant="body2">
                        For {subscription.installments} months.
                      </Typography>
                    </Box>
                  ) : subscription.tier_prices && (
                    <Box>
                      {renderTierPrices(subscription.tier_prices)}
                    </Box>
                  )}
                </Grid>
              </Grid>
            </CardContent>
            <CardActions>
              <form method="POST" action={`${API_URL}/stripe/portal_session/${student.stripe_customer_id}`}>
                <Button type="submit" color="primary">Manage Payment</Button>
              </form>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default SubscriptionDetails;
